var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_32)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 26.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0001 25.7248C26.9931 25.7248 25.3552 27.4212 25.3552 29.4999C25.3552 31.5786 26.9931 33.275 29.0001 33.275C31.0072 33.275 32.6451 31.5786 32.6451 29.4999C32.6451 27.4212 31.0072 25.7248 29.0001 25.7248ZM39.9322 29.4999C39.9322 27.9366 39.9458 26.3875 39.8611 24.8271C39.7763 23.0146 39.3771 21.406 38.0974 20.0806C36.815 18.7524 35.2646 18.3417 33.5146 18.2539C32.0052 18.1661 30.5095 18.1803 29.0029 18.1803C27.4935 18.1803 25.9978 18.1661 24.4911 18.2539C22.7411 18.3417 21.188 18.7552 19.9083 20.0806C18.6259 21.4088 18.2294 23.0146 18.1447 24.8271C18.0599 26.3903 18.0736 27.9395 18.0736 29.4999C18.0736 31.0604 18.0599 32.6123 18.1447 34.1728C18.2294 35.9853 18.6286 37.5939 19.9083 38.9193C21.1908 40.2475 22.7411 40.6581 24.4911 40.7459C26.0005 40.8337 27.4962 40.8195 29.0029 40.8195C30.5122 40.8195 32.0079 40.8337 33.5146 40.7459C35.2646 40.6581 36.8177 40.2446 38.0974 38.9193C39.3798 37.591 39.7763 35.9853 39.8611 34.1728C39.9486 32.6123 39.9322 31.0632 39.9322 29.4999ZM29.0001 35.3084C25.8966 35.3084 23.3919 32.7143 23.3919 29.4999C23.3919 26.2856 25.8966 23.6914 29.0001 23.6914C32.1036 23.6914 34.6083 26.2856 34.6083 29.4999C34.6083 32.7143 32.1036 35.3084 29.0001 35.3084ZM34.838 24.8101C34.1134 24.8101 33.5283 24.204 33.5283 23.4535C33.5283 22.703 34.1134 22.097 34.838 22.097C35.5626 22.097 36.1478 22.703 36.1478 23.4535C36.148 23.6317 36.1143 23.8082 36.0485 23.9729C35.9828 24.1376 35.8863 24.2872 35.7646 24.4132C35.643 24.5393 35.4985 24.6392 35.3395 24.7073C35.1805 24.7754 35.0101 24.8103 34.838 24.8101Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_32",
    x: 0,
    y: 0,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_93_32"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_32"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_32",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.eb0328e6cacda313aa21e0cd74d4ee60.svg";
export { ForwardRef as ReactComponent };